import countries from 'data/countries';
import stepTypes from 'components/Booking-new/modules/Steps/types';
import { getUtms } from 'utils/analytics';
import { getFormattedDateTime } from 'utils/momentHelpers';
import { types } from 'utils/gtm';
import { loadFromLocalStorage } from '../../helpers/loadFromLocalStorage';

const utmsParams = getUtms();
const bodyBase = {
  ptid: '',
  ptsrc: '',
  ambassador_short_code: '',
  ambassador_campaign_id: '',
  locale: countries[process.env.GATSBY_COUNTRY_CODE].lang,
  country_of_service: countries[process.env.GATSBY_COUNTRY_CODE].shortName,
  consent_to_privacy_policy: true,
  consent_to_data_processing: true,
  ...utmsParams,
};

const getSaction = isRescheduling => (isRescheduling ? types.reschedule : types.book);

export const getBookingData = state => {
  const { config, userData } = state;

  const [sdate, stime] = getFormattedDateTime(userData[stepTypes.time]?.time);

  const localUserData = loadFromLocalStorage('submitData');

  const phoneNumber = userData[stepTypes.personalData]?.phoneNumber || localUserData?.phoneNumber;
  const formattedPhone = phoneNumber && !phoneNumber.startsWith('+') ? `+${phoneNumber}` : phoneNumber;

  const body = {
    ...bodyBase,
    firstname: userData[stepTypes.personalData]?.firstName || localUserData?.firstName,
    lastname: userData[stepTypes.personalData]?.lastName || localUserData?.lastName,
    email: userData[stepTypes.personalData]?.email || localUserData?.email,
    phone: formattedPhone,
    sdate: sdate,
    stime: stime,
    service: config?.service?.code,
    location: userData[stepTypes.location].selectedLocation.code,
    saction: getSaction(userData[stepTypes.reschedule]?.appointment?.saction),
    appointmentid: userData[stepTypes.reschedule]?.appointment?.appointmentid || '',
    email_opt_in_step_one:
      userData[stepTypes.personalData]?.marketingConsent || localUserData?.marketingConsent || false,
  };

  if (config?.leadId?.length > 0) body.lead_id = config.leadId;

  return body;
};

export default getBookingData;
